export enum OrganizationType {
  Individual = 'individual',
  Llc = 'llc',
  SCorp = 's-corp',
  CCorp = 'c-corp',
  Partnership = 'partnership',
  SoleProprietorship = 'sole-proprietorship',
  NonProfit = 'non-profit',
  Other = 'other',
}
